<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Autentificare</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                prepend-icon="mdi-email"
                name="email"
                label="email"
                type="email">
              </v-text-field>
              <v-text-field
                v-model="password"
                prepend-icon="mdi-lock"
                name="password"
                label="parola"
                :append-icon="pwdVis ? 'mdi-eye' : 'mdi-eye-off'"
                :type="pwdVis ? 'text' : 'password'"
                @click:append="_cbTogglePwdVis">
              </v-text-field>
            </v-form>
            <v-alert
              v-model="alert"
              dismissible
              type="error">
              {{error}}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="_cbLogin">Intra in aplicatie</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    pwdVis: false,
    email: null,
    password: null,
    error: null,
    alert: false
  }),
  methods: {
    _cbTogglePwdVis () {
      this.pwdVis = !this.pwdVis
    },
    _cbLogin () {
      this.$store.dispatch('login', { email: this.email, password: this.password })
        .then(res => {
          this.$router.push({ name: 'index' })
        })
        .catch(err => {
          console.log(err)
          this.alert = true
          this.error = 'Autentificare esuata...'
        })
    }
  }
}
</script>

<style>

</style>
